import { Component, Input } from '@angular/core'
import { ZoneId } from '@js-joda/core'
import { IconAlignment, IconColor, IconComponent, IconGap } from '../icon'
import { TooltipAlignment, TooltipModule } from '../tooltip'

@Component({
  standalone: true,
  selector: 'ftr-timezone',
  templateUrl: './timezone.component.html',
  imports: [IconComponent, TooltipModule],
})
export class TimezoneComponent {
  @Input({ required: true })
  timezone: ZoneId

  @Input()
  color?: IconColor = 'GreyLight'

  @Input()
  gapLeft: IconGap = 'Tiny'

  @Input()
  tooltipAlignment: TooltipAlignment = TooltipAlignment.END

  @Input()
  iconAlignment: IconAlignment = 'TextBottom'
}
